export default __webpack_public_path__ + "static/media/default.0fc41cae.jpg";